import React from "react";
import "../css/Terms.css";

function Terms() {
  return (
    <div className="container-xxl p-0">
      <div className="terms-container">

        <section>
          <h1>Bharat Jagriti – Terms and Conditions</h1>
          <p>
            Bharat Jagriti is a digital social media platform founded and
            operated by Bhaskar Bhushan. These Terms and Conditions govern the
            access and use of the Bharat Jagriti application, website, and
            related services (collectively referred to as the “Platform”,
            “Service”, or “App”).
          </p>
          <p>
            By creating an account, accessing, or using Bharat Jagriti, users
            agree to comply with these Terms and Conditions. If a user does not
            agree with any part of these terms, they must discontinue use of the
            platform immediately
          </p>

          <p>
            Bharat Jagriti reserves the right to update, modify, replace, or
            amend these Terms and Conditions, Privacy Policy, or Monetization
            Rules at any time. Significant changes may be communicated through
            the platform or other official communication channels. Continued use
            of the platform after such updates constitutes acceptance of the
            revised terms.
          </p>
        </section>

        <section>
          <h2>1. User Conduct and Legal Compliance</h2>
          <p>
            Users agree to use the platform responsibly and in accordance with
            all applicable laws in India, including the Information Technology
            Act, 2000, and other relevant regulations.
          </p>

          <p>Users must not:</p>

          <ul>
            <li>
              Post or distribute pornographic, obscene, sexually explicit, or
              adult content.
            </li>
            <li>
              Engage in harassment, bullying, hate speech, threats, or abusive
              behavior.
            </li>
            <li>
              Publish or promote fake news, misleading information, spam,
              phishing, or deceptive content.
            </li>
            <li>Impersonate another person or misrepresent identity</li>
            <li>
              Violate intellectual property rights including copyrights,
              trademarks, or proprietary rights.
            </li>
            <li>
              Promote illegal activities, terrorism, drugs, violence, or
              criminal acts.
            </li>
            <li>
              Share content that threatens national security, public order, or
              religious harmony
            </li>
            <li>
              Attempt to bypass or manipulate the platform’s security,
              verification, or moderation systems.
            </li>
          </ul>

          <h2>Content Responsibility</h2>
          <p>
            Every post, comment, image, video, or other content uploaded on
            Bharat Jagriti is the sole responsibility of the user who created or
            uploaded it.
          </p>

          <p>
            Bharat Jagriti acts only as an intermediary platform and shall not
            be held responsible for any inappropriate, unlawful, misleading, or
            harmful content posted by users.
          </p>

          <h2>Enforcement</h2>
          <p>Bharat Jagriti reserves the right to:</p>

          <ul>
            <li>
              Remove or restrict access to content that violates these
              terms.{" "}
            </li>
            <li>Suspend or terminate user accounts.</li>
            <li>Restrict platform features for violating users.</li>
            <li>
              Cooperate with law enforcement authorities where required by law
            </li>
          </ul>
        </section>

        <section>
          <h3>2. Account Registration and Identity Verification</h3>

          <p>
            To maintain authenticity and platform integrity, users may be
            required to verify their identity
          </p>
          <p>Verification may involve submission of:</p>

          <ul>
            <li>Aadhaar card</li>
            <li>Mobile number </li>
          </ul>

          <p>
            Verified accounts may receive access to additional platform features
            including increased visibility, participation privileges, or
            monetization opportunities.
          </p>

          <p>
            Users are responsible for ensuring that all information provided
            during registration or verification is accurate, truthful, and up to
            date.
          </p>

          <p>
            Bharat Jagriti reserves the right to suspend, restrict, or remove
            accounts that contain false, misleading, or unverifiable
            information.
          </p>
        </section>

        <section>
          <h2>3. User Categories: Prime and Public Members</h2>

          <p>
            Bharat Jagriti may categorize users into different groups for
            content visibility and engagement
          </p>

          <h2>Prime Members</h2>

          <p>
            Prime accounts are designated and granted solely by the Bharat
            Jagriti platform administration based on internal evaluation, public
            contribution, verification status, or relevance to the platform’s
            community objectives.
          </p>
          <p>
            Prime membership may be offered to certain categories of users,
            including but not limited to:
          </p>

          <ul>
            <li>Public representatives</li>
            <li> Social workers</li>
            <li>Community leaders</li>
            <li>Verified contributors</li>
          </ul>

          <p>
            These categories are provided only as examples of users who may be
            considered eligible for Prime membership.
          </p>
          <p>
            The granting of Prime status is entirely at the discretion of the
            Bharat Jagriti administration. Users cannot request, demand, or
            claim Prime membership as a right.
          </p>

          <p>
            Bharat Jagriti reserves the full authority to approve, deny, modify,
            suspend, or revoke Prime membership at any time without prior notice
            if deemed necessary for platform integrity, policy compliance, or
            community safety.
          </p>
          <h2>Public Members</h2>

          <p>
            Public members are regular verified users identified by a blue
            verification badge.
          </p>
          <p>
            Users cannot independently claim Prime status. The platform reserves
            the right to grant, modify, or revoke account status at its
            discretion.
          </p>
        </section>

        <section>
          <h2>4. Advertising, Promotions, and Sponsored Content</h2>

          <p>
            Users are not permitted to publish advertisements, promotional
            campaigns, or sponsored content without prior authorization from
            Bharat Jagriti.
          </p>

          <h3>All promotional activities must comply with:</h3>

          <ul>
            <li>Applicable Indian advertising laws</li>
            <li>Platform policies</li>
            <li>Ethical disclosure requirements</li>
          </ul>
          <p>
            Users must clearly disclose sponsored or paid promotions when
            authorized
          </p>

          <p>
            Unauthorized advertising, commercial spam, or deceptive promotions
            may result in content removal, account suspension, or permanent
            termination.
          </p>
        </section>

        <section>
          <h2>5. Revolutions and Public Campaigns</h2>

          <p>
            Bharat Jagriti may allow users to organize or promote social
            campaigns, public movements, or revolutions through the platform.
          </p>
          <p>
            The responsibility for organizing or promoting any revolution,
            campaign, or public initiative lies entirely with the user who
            created or initiated it.
          </p>
          <p>
            Bharat Jagriti shall not be responsible for the actions,
            consequences, or outcomes related to any revolution or campaign
            initiated by users.
          </p>
          <p>
            The platform reserves the right to review, approve, reject,
            restrict, or remove any revolution or campaign if it violates:
          </p>

          <h3>Users must not publish</h3>

          <ul>
            <li> Indian laws</li>
            <li>Government regulations</li>
            <li>Platform policies</li>
            <li>Public safety or social harmony</li>
          </ul>
        </section>

        <section>
          <h2>6. Donation System and Fundraising</h2>

          <p>
            Bharat Jagriti may provide a donation or fundraising system for
            eligible users.
          </p>
          <p>
            Donation features will only be available to verified users who are
            legally authorized to receive donations under Indian law.
          </p>
          <p>Users requesting donation features must:</p>

          <ul>
            <li>Possess valid registration of an NGO or Trust</li>
            <li>Provide relevant legal documentation</li>
            <li> Maintain a valid current bank account</li>
            <li>Follow all Indian financial and charity regulations</li>
          </ul>

          <p>
            Bharat Jagriti reserves the right to approve, restrict, or revoke
            donation privileges.
          </p>

          <p>
            The platform will not be responsible for the use, misuse, or
            management of donated funds by users or organizations.
          </p>
        </section>

        <section>
          <h2>7. Political, News, and Public Affairs Content</h2>

          <p>
            Bharat Jagriti operates as an intermediary platform where users
            generate and share content.
          </p>
          <p>
            The platform does not endorse political opinions, news, or public
            commentary posted by users.
          </p>

          <p>Bharat Jagriti operates as an independent digital social platform and is not affiliated with, endorsed by, or officially connected to any political party, political organization, or political group. The platform does not represent or promote the interests of any political entity.</p>

          <h3>Users must not publish</h3>

          <ul>
            <li>Fake or misleading political information</li>
            <li>Content that violates election laws</li>
            <li>Manipulative or deceptive political campaigns</li>
            <li>
              Content intended to mislead voters or disrupt democratic processes
            </li>
          </ul>

          <p>
            The platform reserves the right to review, restrict, or remove
            political content that violates applicable laws or platform
            policies.
          </p>
        </section>

        <section>
          <h2>8. Monetization and Engagement Policy</h2>

          <p>
            Bharat Jagriti may provide monetization opportunities to eligible
            users based on platform engagement and contribution.
          </p>

          <p>Participation in monetization programs:</p>

          <ul>
            <li>Is voluntary and discretionary</li>
            <li>
              Does not establish employment, partnership, or contractual
              entitlement
            </li>
          </ul>

          <h2>Eligibility</h2>
          <p>Monetization may depend on factors including:</p>

          <ul>
            <li>Account verification</li>
            <li>Engagement metrics</li>
            <li>Content quality</li>
            <li>Platform policy compliance</li>
          </ul>

          <h2>User Categories</h2>

          <h4>Prime Users</h4>
          <ul>
            <li>
              May be eligible for monetization from the start of participation.
            </li>
            <li>
              Earnings may be calculated using proprietary engagement
              algorithms.
            </li>
          </ul>

          <h4>Public Users</h4>

          <ul>
            <li>
              May qualify for monetization after meeting engagement or follower
              thresholds.
            </li>
          </ul>


          <h4>Withdrawal Limit</h4>
          <p>
            For both Prime Users and Public Users, monetization earnings can only be withdrawn after reaching the minimum withdrawal threshold of ₹5,000. Once the threshold is achieved, users may request withdrawal of their eligible earnings through the platform’s withdrawal process.

          </p>


          <h4>Monetization Rate Changes</h4>
          <p>
            Monetization rates, earnings calculations, and reward structures may vary from time to time based on market conditions, platform policies, advertiser demand, engagement trends, and other business factors.
          </p>

          <h2>Engagement Integrity</h2>

          <p>Users must not attempt to manipulate engagement through:</p>
          <ul>
            <li>Bots</li>
            <li>Fake followers</li>
            <li>Paid likes or artificial activity</li>
          </ul>

          <p>Any attempt to manipulate platform engagement may result in:</p>

          <ul>
            <li>Removal from monetization programs</li>
            <li>Adjustment or forfeiture of earnings</li>
            <li>Account suspension</li>
          </ul>

          <h4>Limitation of Liability</h4>

          <p>
            To the maximum extent permitted by applicable law, Bharat Jagriti
            and its operators shall not be liable for any direct, indirect,
            incidental, consequential, or special damages arising from:
          </p>

          <ul>
            <li> User-generated content</li>
            <li> Platform misuse</li>
            <li>Unauthorized access to user accounts</li>
            <li>Service interruptions or technical issues</li>
            <li>Loss of data, revenue, or business opportunities</li>
          </ul>

          <p>
            Users acknowledge that the platform is provided “as is” and “as
            available”, without guarantees of uninterrupted or error-free
            operation. Use of the platform is at the user’s own risk.
          </p>

          <h4>Dispute Resolution and Arbitration</h4>

          <p>
            Users agree that any disputes arising from the use of the Bharat
            Jagriti platform will first be resolved through good-faith
            negotiation between the user and the platform administration.
          </p>
          <p>
            If a dispute cannot be resolved through negotiation, the matter may
            be referred to arbitration or mediation in accordance with
            applicable laws in India
          </p>

          <p>
            All legal matters relating to the use of the platform shall be
            governed by the laws of India.
          </p>
          <p>
            Any legal proceedings shall fall under the exclusive jurisdiction of
            the courts in India.
          </p>

          <h4>Updates to Community Guidelines</h4>

          <p>
            These Community Guidelines may be updated periodically to reflect
            changes in laws, regulations, or platform policies.
          </p>

          <p>
            Users are encouraged to review these guidelines regularly to remain
            informed about acceptable behavior on the platform.
          </p>

          <p>
            Continued use of the platform indicates acceptance of any updated
            guidelines.
          </p>

          <h4>Commitment to a Safe Community</h4>

          <p>
            Bharat Jagriti is committed to creating a safe, respectful, and
            responsible digital community where users can share ideas, discuss
            social issues, and engage constructively.
          </p>

          <p>
            All users play a role in maintaining the integrity and safety of the
            platform.
          </p>

          <p>
            By following these guidelines, users help create a positive and
            trustworthy environment for everyone.
          </p>

          <h4>Payments</h4>

          <p>Withdrawals may require:</p>
          <ul>
            <li>Identity verification (KYC)</li>
            <li>Compliance with applicable financial regulations</li>
          </ul>

          <p>
            Payment processing may take 7–60 business days depending on
            verification and payment method.
          </p>

          <p>
            Users are solely responsible for tax reporting and compliance
            related to any earnings received through the platform.
          </p>
        </section>
      
        <section className="policy-section">
          <h2>9 : Contact Information</h2>
          <p>
            For privacy inquiries, account deletion requests, or legal concerns,
            users may contact:
          </p>
          <p>
            <small>Bhaskar Bhushan</small>Founder – Bharat Jagriti
          </p>
          <p>
            Email:
            <a href="mailto:ceo@bharatjagriti.com">ceo@bharatjagriti.com</a>
          </p>
        </section>

        <footer className="privacy-footer">
          © {new Date().getFullYear()} Bharat Jagriti. All Rights Reserved.
        </footer>
      </div>
    </div>
  );
}

export default Terms;